import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7632c073"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sku-box" }
const _hoisted_2 = {
  key: 0,
  class: "sku-inner-box"
}
const _hoisted_3 = { class: "sku-add-operat-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "如有颜色、尺码等多种规格，请添加商品规格", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sku_item = _resolveComponent("sku-item")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, index) => {
            return (_openBlock(), _createBlock(_component_sku_item, {
              modelValue: _ctx.modelValue[index],
              "onUpdate:modelValue": ($event: any) => ((_ctx.modelValue[index]) = $event),
              cover: index == 0,
              onDestory: ($event: any) => (_ctx.removeIndex(index)),
              key: index
            }, null, 8, ["modelValue", "onUpdate:modelValue", "cover", "onDestory"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, { onClick: _ctx.addItem }, {
        default: _withCtx(() => [
          _createTextVNode("添加规格")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_4
    ])
  ]))
}